import { Component, Input, OnInit, forwardRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { Subscription } from 'rxjs';
import { IconSelectData } from '@platform500services/p500-ui-kit';
import { PaymentType } from '../payment-account/enums/payment-types.enum';

@Component({
  selector: 'gtd-currency-field',
  templateUrl: './currency-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CurrencyFieldComponent),
    },
  ],
})
@DestroySubscribers()
export class CurrencyFieldComponent implements ControlValueAccessor, OnInit {
  @Input() label = 'Currency';
  @Input() required = true;
  @Input() readonly = false;
  @Input() data: IconSelectData;

  public control: UntypedFormControl;
  public dependControl: UntypedFormControl;
  public subscribers: Record<string, Subscription> = {};
  public value: string;
  public currencyOptionsByPaymentSystem: any;
  public selectedData: string;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    const currencies = { USD: this.data.USD, EUR: this.data.EUR, ...this.data };

    this.currencyOptionsByPaymentSystem = {
      [PaymentType['Wire Transfer']]: this.data,
      [PaymentType.TRC20]: { USDT: this.data.USDT },
      [PaymentType.ERC20]: { USDT: this.data.USDT },
      [PaymentType.BTC]: currencies,
      [PaymentType.Neteller]: currencies,
      [PaymentType.Skrill]: currencies,
    };

    this.subscribers.dependControl = this.dependControl.valueChanges.subscribe((value) => {
      this.data = this.currencyOptionsByPaymentSystem[value];

      if (value === PaymentType.ERC20 || value === PaymentType.TRC20) {
        this.handleChange('USDT');
        this.readonly = true;
      } else {
        this.readonly = false;
      }
      this.cd.markForCheck();
    });
  }

  public onChange: (value: string) => void = () => {};
  public onTouch = () => {};

  registerOnChange(fn: (value) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  handleChange(value: string): void {
    this.selectedData = value;
    this.control.patchValue(this.selectedData);
    this.cd.markForCheck();
  }

  writeValue(value: string): void {
    this.selectedData = value;
    this.onChange(this.selectedData);
    this.cd.markForCheck();
  }
}
